module.exports = {"showInFunnel":"false","color1":"#0082C3","color2":"","texto":"","textoMovil":""}


//////////////////
// WEBPACK FOOTER
// ./src/_override/static/json/libelle.json
// module id = 1042
// module chunks = 33